import { observer } from "mobx-react-lite"
import Checkbox from "@mui/material/Checkbox"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import FormControlLabel from "@mui/material/FormControlLabel"
import { ProposalStep2ServiceDto } from '@gap/backend/app-services/proposal/models/ProposalStep2Dto';
import LexicalRichTextEditor, { LexicalMode } from "reusable/rich-text-editors/lexical/LexicalRichTextEditor"
import { useProposalsViewProposalStore } from "../../ProposalsViewProposalStore"

export default observer(function ServiceItem({ service, selection }: ServiceItemProps) {
   const { serviceId, serviceName, serviceDefinition, serviceHowItWorks } = service
   const { currentSignee } = useProposalsViewProposalStore()

   const onSelectionChange = selection?.onSelectionChange
      ? () => selection.onSelectionChange?.({ serviceId, selected: !selection.isSelected })
      : undefined

   return (
      <FormControlLabel
         sx={{
            margin: 0,
            gap: '10px',
            alignItems: 'flex-start',
            '.MuiFormControlLabel-label': {
               marginTop: .5,
               '&.Mui-disabled': {
                  color: 'inherit',
               },
            },
         }}
         control={
            <Checkbox
               disabled={!selection.enabled || service.servicePriceType === 'agreed' || !currentSignee}
               checked={selection.isSelected}
               onChange={onSelectionChange}
               sx={{
                  marginLeft: '-8px',
                  marginTop: '-1px',
                  ...(service.servicePriceType === 'agreed' ? { visibility: 'hidden' } : {}),
               }}
            />
         }
         label={
            <Stack>
               <Typography variant="subtitle1" sx={{ mb: .5 }}>{serviceName}</Typography>
               {serviceDefinition &&
                  <Typography variant="body1" sx={{ mb: 2 }}>{serviceDefinition}</Typography>}
               {serviceHowItWorks && <>
                  <Typography variant="body2" sx={{ mb: .5, fontWeight: 'bold' }}>How it works</Typography>
                  <LexicalRichTextEditor value={serviceHowItWorks} mode={LexicalMode.View} disabled={true} />
               </>}
            </Stack>
         }
      />
   );
})

type ServiceItemProps = {
   service: ProposalStep2ServiceDto,
} & ServiceSelectionProps

type ServiceSelectionProps = {
   selection: {
      enabled: boolean,
      isSelected: boolean,
      onSelectionChange?: ServiceSelectionChangeListener,
   }
}

export type ServiceSelectionChangeListener = (event: { serviceId: string, selected: boolean }) => any